'use strict';
$(document).ready(function() {

    /* Toggle radio buttons */
    $('form input[type=radio]').click(function() {
        /* TODO Target parent div and add class 'checked' */
        $(this).addClass('checked');
        /* TODO Target parent div's sibling and remove class 'checked' */
        $(this).removeClass('checked');
    });

    /* Toggle checkboxes */
    $('form input[type=checkbox]').click(function() {
        /* TODO Target parent div and add class 'checked' */
        $(this).addClass('checked');
        /* TODO Target parent div's sibling and remove class 'checked' */
        $(this).removeClass('checked');
    });

});